// src/stone/illustrations/StonjiPercentGreenIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPercentGreenIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M.25 0h80v80h-80z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M65.491 17.255a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M15.008 67.745a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M63.739 12.976 13.24 63.473l3.536 3.535 50.497-50.497z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M60.239 44.969a10.024 10.024 0 0 0-7.09 17.114 10.026 10.026 0 1 0 7.09-17.114m0 14.985a4.958 4.958 0 1 1-.01-9.917 4.958 4.958 0 0 1 .01 9.917M20.266 15.012a10.026 10.026 0 1 0 0 20.051 10.026 10.026 0 0 0 0-20.051m0 14.985a4.96 4.96 0 1 1 0-9.92 4.96 4.96 0 0 1 0 9.92"
        }
      )
    ]
  }
);
var StonjiPercentGreenIllustration_default = StonjiPercentGreenIllustration;

export {
  StonjiPercentGreenIllustration_default
};
